import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './components/layout/Header';
import Sidebar from './components/layout/Sidebar';
import Dashboard from './pages/Dashboard';
import Search from './pages/Search';
import Categories from './pages/Categories';
import TechnicalDocs from './pages/TechnicalDocs';
import ProductDetail from './pages/ProductDetail';
import Bearings from './pages/Bearings';
import Seals from './pages/Seals';
import Linear from './pages/Linear';
import { DatabaseProvider } from './context/DatabaseContext';
import './App.css';

function App() {
  return (
    <DatabaseProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Header />
          <div className="flex">
            <Sidebar />
            <motion.main
              className="flex-1 ml-64 p-6 pt-20"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/search" element={<Search />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/technical-docs" element={<TechnicalDocs />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/bearings" element={<Bearings />} />
                <Route path="/seals" element={<Seals />} />
                <Route path="/linear" element={<Linear />} />
              </Routes>
            </motion.main>
          </div>
        </div>
      </Router>
    </DatabaseProvider>
  );
}

export default App;